<script lang="ts">
import {setReturnMsg} from '../setXK852Status';
</script>

<div>
<h1>Test</h1>
{setReturnMsg("*F1407400K  I2B   J9G0N0V0Z1H1S0")}
</div>